import { optionSubcategory_layout } from './layoutSubCategory.locstring.json';
import ConversationsOption from 'owa-conversations-option/lib/ConversationsOption';
import DateHeadersOption from 'owa-date-headers-option/lib/DateHeadersOption';
import { DisplayDensityOption } from 'owa-display-density-option';
import FocusedInboxOption from 'owa-focused-option/lib/FocusedInboxOption';
import InlinePreviewsOption from 'owa-inline-previews-option/lib/InlinePreviewsOption';
import MessagePreviewOption from 'owa-message-preview-option/lib/MessagePreviewOption';
import NudgeOption from 'owa-nudge-option/lib/NudgeOption';
import { OptionSubCategory } from 'owa-options-core';
import ReadingPaneOption from 'owa-reading-pane-option/lib/ReadingPaneOption';
import SenderImageOption from 'owa-sender-image-option/lib/SenderImageOption';
import SenderSubjectOption from 'owa-sender-subject-option/lib/SenderSubjectOption';

let layoutSubCategory: OptionSubCategory = {
    key: 'layout',
    titleStringKey: optionSubcategory_layout,
    options: [
        FocusedInboxOption,
        DisplayDensityOption,
        ConversationsOption,
        SenderImageOption,
        ReadingPaneOption,
        SenderSubjectOption,
        MessagePreviewOption,
        InlinePreviewsOption,
        DateHeadersOption,
        NudgeOption,
    ],
};

export default layoutSubCategory;
